/**
 * Product Model
 * Wat zit er in je potje?
 */

// Cijfers (zoals op school)
export type Grade =
  | 'A+' | 'A' | 'A-'
  | 'B+' | 'B' | 'B-'
  | 'C+' | 'C' | 'C-'
  | 'D+' | 'D' | 'D-'
  | 'E+' | 'E' | 'E-';

// Kleurtjes bij de cijfers
export const GRADE_COLORS: Record<Grade, string> = {
  'A+': '#22C55E', 'A': '#22C55E', 'A-': '#22C55E',  // Groen
  'B+': '#84CC16', 'B': '#84CC16', 'B-': '#84CC16',  // Lichtgroen
  'C+': '#EAB308', 'C': '#EAB308', 'C-': '#EAB308',  // Geel
  'D+': '#F97316', 'D': '#F97316', 'D-': '#F97316',  // Oranje
  'E+': '#EF4444', 'E': '#EF4444', 'E-': '#EF4444',  // Rood
};

// Waarom het goed of slecht is
export interface SustainabilityFactor {
  icon: string;           // Emoji of icoon naam (🧪, 📦, 🐰)
  label: string;          // "Ingrediënten", "Verpakking", "Ethiek"
  description: string;    // Uitleg
  description_en?: string; // Uitleg in het Engels
}

// Hoe het uit de database komt rollen
export interface Product {
  nummer: number;           // Product ID uit database
  product: string;          // Product naam
  merk: string;            // Merk naam
  categorie: string;       // Categorie
  milieuRating: string;    // Milieu cijfer (A+ tot E-)
  waaromRating: string;    // Algemene reden voor cijfer
  waaromRating_en?: string; // Algemene reden in Engels
  reason1?: string;        // Eerste duurzaamheidsfactor
  reason1_en?: string;     // Reden 1 in het Engels
  reason2?: string;        // Tweede duurzaamheidsfactor
  reason2_en?: string;     // ...
  reason3?: string;        // Derde duurzaamheidsfactor
  reason3_en?: string;
  reason4?: string;        // Vierde duurzaamheidsfactor
  reason4_en?: string;
  barcode?: string;        // EAN-13 of UPC barcode
  turbidity?: number;      // Turbidity value from database
  ph?: number;             // pH value from database
  tds?: number;            // TDS value from database
  imageUrl?: string;       // Plaatje van het product
}

// Netjes gemaakt voor de app
export interface ProductDisplay {
  id: number;
  name: string;
  brand: string;
  category: string;
  grade: Grade;
  overallReason: string;
  overallReason_en?: string; // Engelse reden
  sustainabilityFactors: SustainabilityFactor[];
  barcode?: string;
  imageUrl?: string;
  // Water dingetjes
  phLevel?: number;      // pH waarde (0-14, 7 is top)
  tdsValue?: number;     // Deeltjes in het water (ppm)
  turbidity?: number;    // Hoe troebel het is (NTU)
}

// Database rij definitie (precies zoals in de tabel)
export interface ProductDatabaseRow {
  Nummer: number;
  Product: string;
  Merk: string;
  Categorie: string;
  'Milieu Rating (A+ tot E-)': string;
  'Waarom deze rating? (Impact op water/aquatisch leven)': string;
  'WaaromRating_EN'?: string;
  Reason_1?: string;
  Reason_1_EN?: string;
  Reason_2?: string;
  Reason_2_EN?: string;
  Reason_3?: string;
  Reason_3_EN?: string;
  Reason_4?: string;
  Reason_4_EN?: string;
  Barcode?: string;
  Turbidity?: number;
  Ph?: number;
  Tds?: number;
  ImageUrl?: string;
}
